module.exports = __webpack_public_path__ + "img/bbm.2d6002e1.gif";